import { z } from 'zod/v4-mini';

import { flatPhoneSchema } from '@/models/PhoneModel';
import { Schema, cz } from '@/utils/zodUtils.ts';

export const contactTypeSchema = z.literal([
  'ide',
  'aidant',
  'famille',
  'autre',
]);
export type ContactType = z.infer<typeof contactTypeSchema>;
export const contactRelationshipSchema = z.literal([
  'grand_parent',
  'parent',
  'parent_in_law',
  'partner',
  'child',
  'brother',
  'cousin',
  'friend',
  'other',
]);
export type ContactRelationship = z.infer<typeof contactRelationshipSchema>;

export type Contact = {
  userId: string;
  id: string;

  type?: ContactType;
  firstname?: string;
  lastname?: string;
  email?: string;
  postalAddress?: string;
  // TODO proper city / post code with address
  phone?: string;
  comment?: string;
  isEmergencyContact: boolean;

  relationshipWithPatient?: ContactRelationship;
};

export const contactSchema: Schema<Contact> = z.pipe(
  z.object({
    patient: z.string(),
    id: cz.id(),
    first_name: cz.optional(z.string()),
    last_name: cz.optional(z.string()),
    email: cz.optional(z.string()),
    postal_address: cz.optional(z.string()),
    phones: cz.optional(flatPhoneSchema),
    comment: cz.optional(z.string()),
    is_emergency_contact: z.boolean(),
    type: cz.optional(contactTypeSchema),
    relationship_with_patient: cz.optional(contactRelationshipSchema),
  }),
  z.transform(data => ({
    userId: data.patient,
    id: data.id,
    type: data.type,
    firstname: data.first_name,
    lastname: data.last_name,
    email: data.email,
    postalAddress: data.postal_address,
    phone: data.phones,
    comment: data.comment,
    isEmergencyContact: data.is_emergency_contact,
    relationshipWithPatient: data.relationship_with_patient,
  })),
);
